import {fixupHueLonger, fixupHueShorter, samples, interpolate, formatHex} from 'culori';

export default {
// originally from https://www.learnui.design/tools/data-color-picker.html#palette
  create: function(first, last) {
    let numStops = 2;
    
    let firstColor = first;
    let lastColor = last;
    let interpDirection = 'short';
    let fixup = interpDirection === 'long' ? fixupHueLonger : fixupHueShorter;
    
    let colorScales = [[first], [first, last]];
    for (let numStops = 3; numStops < 11; numStops++) {

      colorScales.push(samples(numStops)
        .map(interpolate([firstColor, lastColor], "lch", {
          h: {fixup: fixup}
        }))
        .map(formatHex));
    }
    return colorScales;
  }
};
